


































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'

@Component
export default class ModalFiltroPorProcedimentoIncluir extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadAddRegraCalculoOperadora: boolean = false
  get loadingAddRegraCalculoOperadora() { return this.loadAddRegraCalculoOperadora }
  set loadingAddRegraCalculoOperadora(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get showModalFiltroPorProcedimento() { return this.getRegrasDeCalculoStore.modal.filtroProcedimento }
  set showModalFiltroPorProcedimento(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'filtroProcedimento', value }) }

  get codigo() { return this.getRegrasDeCalculoStore.codigoFiltroProcedimento }
  set codigo(value: string) { this.getRegrasDeCalculoStore.setCodigoFiltroProcedimento(value) }

  get descricao() { return this.getRegrasDeCalculoStore.descricaoFiltroProcedimento }
  set descricao(value: string) { this.getRegrasDeCalculoStore.setDescricaoFiltroProcedimento(value) }

  valorGarantiaMinimaRule = (value: any) => !!value || 'O valor é obrigatório.'
  onlyFloatUtil(value: number) { return onlyFloat(value) }

  async addProcedimento() {
    this.loadingAddRegraCalculoOperadora = true
    const request = await this.getRegrasDeCalculoStore.postFiltroPorProcedimento()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculoOperadora = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculoOperadora = false
    this.showModalFiltroPorProcedimento = false
  }

  @Watch('showModalFiltroPorProcedimento')
  onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.setCodigoFiltroProcedimento('')
      this.getRegrasDeCalculoStore.setDescricaoFiltroProcedimento('')
    }
  }
}
